import _extends from "@babel/runtime/helpers/extends";
import React from "react";
import InfoOutlined from "@mui/icons-material/InfoOutlined";
import { makeStyles } from "../Utilities/ThemeHelper";
import classNames from "classnames";
import Popover from "../Popover";
import Button from "../Button";
const useStyles = makeStyles(theme => ({
  popover: {
    borderRadius: theme.shape.borderRadius,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(1)
  },
  helperButton: {
    padding: theme.spacing(0.5),
    marginRight: theme.spacing(0.8)
  }
}));
export const PopoverButton = props => {
  const {
    id,
    className,
    popoverText,
    customHelperIcon,
    PopoverProps,
    onClick,
    ...otherProps
  } = props;
  const [anchorEl, setAnchorEl] = React.useState(null);
  const handleClick = event => {
    setAnchorEl(event.currentTarget);
    if (onClick) onClick(event);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const classes = useStyles(props);
  if (!popoverText) return /*#__PURE__*/React.createElement(React.Fragment, null);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, _extends({
    className: classNames("prmbl-icon-button", classes.helperButton, className),
    type: "icon",
    onClick: handleClick,
    "aria-describedby": `${id}-popover`,
    "aria-owns": anchorEl ? "mouse-over-popover" : undefined,
    "aria-haspopup": "true",
    "aria-expanded": Boolean(anchorEl),
    "aria-label": "Get additional help",
    size: "small",
    color: anchorEl ? "primary" : "default"
  }, otherProps), customHelperIcon ? customHelperIcon : /*#__PURE__*/React.createElement(InfoOutlined, {
    className: classNames("prmbl-formLabel-icon-svg"),
    fontSize: "small"
  })), /*#__PURE__*/React.createElement(Popover, _extends({
    "data-testid": "popover",
    id: `${id}-popover`,
    anchorEl: anchorEl,
    open: Boolean(anchorEl),
    onClose: handleClose,
    anchorOrigin: {
      vertical: "top",
      horizontal: "center"
    },
    transformOrigin: {
      vertical: "bottom",
      horizontal: "center"
    }
  }, PopoverProps, {
    className: classNames("prmbl-popover", classes.popover, PopoverProps?.className)
  }), popoverText));
};
export default PopoverButton;